export default {
  notifPrefs: {
    title: "Alert preferences",
  },
};
